import { useEffect, useMemo, useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Introduction from "@/components/site/Introduction";
import Highlights from "@/components/site/Highlights";
import Mussoorie from "@/components/site/Mussoorie";
import Experience from "@/components/site/Experience";
import WhoFor from "@/components/site/WhoFor";
import ExtendedStays from "@/components/site/ExtendedStays";
import Gallery from "@/components/site/Gallery";
import Amenities from "@/components/site/Amenities";
import Food from "@/components/site/Food";
import Location from "@/components/site/Location";
import Testimonials from "@/components/site/Testimonials";
import EnquiryForm from "@/components/site/EnquiryForm";
import Contact from "@/components/site/Contact";
import FAQ from "@/components/site/FAQ";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import { api } from "@/lib/api";
import { useReveal } from "@/lib/useReveal";
import { imagesByPlacement } from "@/lib/images";

export default function Landing() {
  const [content, setContent] = useState({
    testimonials: [],
    amenities: [],
    faqs: [],
    images: [],
    contact: {
      phone: "[PHONE NUMBER]",
      email: "[EMAIL ADDRESS]",
      whatsapp: "[WHATSAPP NUMBER]",
      address: "Dehradun, Uttarakhand",
      instagram: "[INSTAGRAM HANDLE]",
      maps_embed_url: "",
    },
  });

  useEffect(() => {
    api
      .get("/content")
      .then((res) => setContent((c) => ({ ...c, ...res.data })))
      .catch(() => {});
  }, []);

  useReveal();

  const buckets = useMemo(() => imagesByPlacement(content.images || []), [content.images]);

  return (
    <div className="bg-[#F7F5F0] min-h-screen">
      <Header />
      <main>
        <Hero image={buckets.hero[0]} />
        <Introduction image={buckets.intro[0]} />
        <Mussoorie images={buckets.mussoorie} />
        <Highlights />
        <Experience images={buckets.experience} />
        <WhoFor />
        <ExtendedStays />
        <Gallery images={buckets.gallery} />
        <Amenities amenities={content.amenities} />
        <Food image={buckets.food[0]} />
        <Location mapsEmbedUrl={content.contact?.maps_embed_url} />
        <Testimonials items={content.testimonials} />
        <EnquiryForm />
        <Contact contact={content.contact} />
        <FAQ items={content.faqs} />
        <FinalCTA phone={content.contact?.phone} />
      </main>
      <Footer contact={content.contact} />
      <FloatingWhatsApp whatsapp={content.contact?.whatsapp} />
    </div>
  );
}
